import { redirect, type RouteObject } from 'react-router'

import { routeCrumb } from '../client/components/Admin/TopNavBar/utils/routeCrumb.js'

export const contentRoutes: RouteObject = {
  path: 'content',
  async lazy() {
    const { ContentRouteBreadCrumb } = await import(
      '../client/components/Admin/Content/ContentRoute.js'
    )
    const { RouteContainer } = await import(
      '../client/components/Container/RouteContainer.js'
    )

    return {
      Component: RouteContainer,
      handle: routeCrumb(ContentRouteBreadCrumb),
    }
  },
  children: [
    {
      index: true,
      loader: () => redirect('posts'),
    },
    {
      path: 'posts',
      async lazy() {
        const { Posts, PostsCrumb } = await import(
          '../client/components/Admin/Posts/index.js'
        )

        return {
          Component: Posts,
          handle: routeCrumb(PostsCrumb),
        }
      },
    },
    {
      path: 'events',
      async lazy() {
        const { AdminEvents, EventsCrumb } = await import(
          '../client/components/Admin/Events/index.js'
        )

        return {
          Component: AdminEvents,
          handle: routeCrumb(EventsCrumb),
        }
      },
    },
    {
      path: 'spaces',
      async lazy() {
        const { Spaces, SpacesCrumb } = await import(
          '../client/components/Admin/Spaces/index.js'
        )

        return {
          Component: Spaces,
          handle: routeCrumb(SpacesCrumb),
        }
      },
    },
    {
      path: 'tags',
      async lazy() {
        const { Tags, TagsCrumb } = await import(
          '../client/components/Admin/Tags/index.js'
        )

        return { Component: Tags, handle: routeCrumb(TagsCrumb) }
      },
    },
  ],
}
